import React, { ReactNode } from "react";
import cn from "classnames";
import s from "./HeroSection.module.scss";
import { HeroSectionProvider } from "./components/HeroSectionContext";
import LogoListWrapper from "./components/LogoListWrapper";

type Props = {
  children: ReactNode;
  hasLogoListBelow?: boolean;
};

type CWSType<P, S> = React.FC<P> & S;

const subComponents = { LogoListWrapper };
type SubComponents = typeof subComponents;

const HeroSection: CWSType<Props, SubComponents> = ({
  children,
  hasLogoListBelow = false,
}) => {
  return (
    <HeroSectionProvider hasLogoListBelow={hasLogoListBelow}>
      <div
        className={cn(s.heroSection, {
          [s.hasLogoList]: hasLogoListBelow,
        })}
      >
        {children}
      </div>
    </HeroSectionProvider>
  );
};

HeroSection.LogoListWrapper = LogoListWrapper;

export default HeroSection;
